import $ from 'jquery'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import FolderForm from 'scoreboard/components/folder-form'

/**
 * Creates a function for folder creation that should work for simple use cases.
 * Can only be used as part of a router that extends {@link BaseRouter}.
 *
 * @param needsCalendar true if the section needs a calendar in order to create
 * 		                entities
 * @param clearNav|header See {@link BaseRouter#handleNoCalendars}
 */
export default function(needsCalendar, { clearNav, header } = {}) {
	return function(relativeId, orgId) {
		orgId = orgId ?? globals.orgId
		if (needsCalendar && this.handleNoCalendars(
			{ clearNav, header: i18n.get(header) })) {
			return
		}

		$.when(this._resolveOrg(relativeId, orgId)).done(parentId => {
			orgId = orgId ?? globals.orgId
			var folder = new this.Model({
				relativeId: parentId,
				organizationId: orgId,
				type: 'folder',
				icon: 'folder'
			})
			var form = new FolderForm({
				model: folder,
				tabs: viewEditTabs,
				overviewTabCode: 'common.view'
			})
			this.navForNewModel({
				relativeId: parentId,
				orgId,
				form,
				model: folder
			})
		})
	}
}